import Clickable from '@uikit/components/Clickable/Clickable';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import Stack from '@uikit/components/Stack/Stack';
import { Badge } from '../Badge/Badge';
import { BlockBadge } from '../BlockBadge/BlockBadge';
import { Headline } from '../Headline/Headline';
import { PricingBox } from '../PricingBox/PricingBox';
import { Text } from '../Text/Text';
import styles from './HomeAdvantage.module.scss';

export const PromoContent = () => {
  return (
    <>
      <Headline className={styles.title} color="gradient">
        Sparen Sie mit unserer easyGo Osteraktion!
      </Headline>

      <div className={styles.description}>
        <Stack
          gap={{ initial: '1rem', sm: '1.5rem' }}
          flexDirection={{ initial: 'column' }}
          justifyContent="center"
          alignItems="center"
        >
          <Text
            size={18}
            desktopScale={1.2}
            lineHeight={1.5}
            weight={300}
            align="center"
          >
            Egal ob für den Familienbesuch, den Osterurlaub oder einfach nur
            zuhause:
            <br />
            <strong>Vom 12. bis zum 21. April</strong> profitieren Sie an über
            1.000 enercity-Ladepunkten von exklusiven Sonderkonditionen und
            sparen <strong>5 ct/kWh</strong>!
          </Text>
          <Text
            size={18}
            desktopScale={1.2}
            lineHeight={1.5}
            weight={300}
            align="center"
          >
            <span>Noch kein(e) enercity easyGo-Kund:in?</span>
            <br />
            <strong>
              <Clickable actionType={ClickableAction.Anchor} anchor="contact">
                Jetzt registrieren und profitieren!
              </Clickable>
            </strong>
          </Text>
        </Stack>
      </div>

      <div className={styles.priceWrapper}>
        <Stack
          gap={{ initial: '0.5rem', sm: '1.5rem' }}
          flexDirection={{ initial: 'column', sm: 'row' }}
          justifyContent="center"
          alignItems="center"
        >
          <BlockBadge className={styles.blockBadge}>
            <Text size={16} color={'default'}>
              <strong>Keine Grundgebühr</strong>
            </Text>
          </BlockBadge>

          <Badge className={styles.badge}>
            <strong>Keine</strong>
            <strong>Grundgebühr</strong>
          </Badge>

          <PricingBox
            label={'Normales Laden (AC)'}
            oldPrice={0.45}
            price={0.4}
            subLabel={'Standzeitzuschlag'}
            subPrice={0.05}
            disclaimer={'ab der 240. Minute nach Beginn eines Ladevorgangs'}
          />
          <PricingBox
            label={'Schnelles Laden (DC)'}
            oldPrice={0.55}
            price={0.5}
            subLabel={'Standzeitzuschlag'}
            subPrice={0.05}
            disclaimer={'ab der 60. Minute nach Beginn eines Ladevorgangs'}
          />
        </Stack>
      </div>
    </>
  );
};
